import { useState as u, useEffect as h } from "react";
const a = (e) => {
  const [r, n] = u({ width: 0, height: 0 });
  return h(() => {
    const t = new ResizeObserver((o) => {
      for (const s of o) {
        const { width: i, height: c } = s.contentRect;
        n({
          width: Math.round(i),
          height: Math.round(c)
        });
      }
    });
    return e.current && t.observe(e.current), () => {
      e.current && t.unobserve(e.current);
    };
  }, []), r;
};
export {
  a as useContainerSize
};
